import { z } from 'zod';
import { definePath } from '../../router/definePath';

const unsubscribeSearch = z.object({
  // Per the auth service's `POST /api/user-reference-token` swagger doc, unsubscribe tokens are
  // signed JWTs. If that ever changes, legitimate links fail shape validation here too. A
  // non-JWT value degrades to `undefined` (invalid-link notice) instead of throwing.
  token: z.jwt().optional().catch(undefined),
  campaign: z.string().optional(),
});

export const NotificationPaths = {
  overview: definePath('authenticated', { de: '/konto/benachrichtigungen', en: '/account/notifications' }),
  unsubscribe: definePath(
    'public',
    { de: '/konto/benachrichtigungen/abmelden', en: '/account/notifications/unsubscribe' },
    { search: unsubscribeSearch },
  ),
  /** Legacy pre-/account-IA URLs, kept indefinitely for old bookmarks and emails. */
  legacyOverview: definePath('authenticated', { de: '/benachrichtigungen', en: '/notifications' }),
  legacyUnsubscribe: definePath(
    'public',
    { de: '/benachrichtigungen/abmelden', en: '/notifications/unsubscribe' },
    { search: unsubscribeSearch },
  ),
} as const;
